import IProvider from '@/contracts/core/provider/interface/IProvider'

export abstract class Provider<T = unknown> implements IProvider<T> {
	abstract realizations: Record<string, T>

	module(version: string): T {
	  const mod = this.realizations[version]
	  if (!mod) {
	    throw new Error('Unknown ' + <T>+' version: ' + version)
	  }
	  return mod
	}
}
